import { Component, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-b2b-model',
	templateUrl: './b2b-model.component.html',
	styleUrls: ['./b2b-model.component.scss'],
})
export class B2bModelComponent implements OnInit {
	@Input() data: any = {}

	icons = [
		'assets/images/b2b-model/icon-agua-purificada.png',
		'assets/images/b2b-model/icon-operacao-simplificada.svg',
		'assets/images/b2b-model/icon-previsibilidade-financeira.svg',
		'assets/images/b2b-model/icon-impacto-ambiental.svg',
	]

	slideConfig = {
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		mobileFirst: true,
		swipeToSlide: true,
		variableWidth: true,
		touchThreshold: 4,
	}

	constructor() {}

	ngOnInit(): void {}
}
